import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { RootState } from "@/types/RootState";

interface SntBrowserTabTitleProps {
  title?: string;
}

const SntBrowserTabTitle: React.FC<SntBrowserTabTitleProps> = ({ title }) => {
  const customInterface = useSelector(
    (state: RootState) => state.customInterface
  );

  const renderEls = () => {
    let el: JSX.Element;

    if (customInterface) {
      el = (
        <Helmet>
          <title>{title || "Home"}</title>
          {customInterface.loginTitle && (
            <meta
              name="application-name"
              content={customInterface.loginTitle}
            />
          )}
          {customInterface.loginTitle && (
            <meta name="description" content={customInterface.loginTitle} />
          )}
          {customInterface.loginTitle && (
            <meta name="keywords" content={customInterface.loginTitle} />
          )}
        </Helmet>
      );
    } else {
      el = (
        <Helmet>
          <title>{title || "Home"}</title>
          <meta
            name="description"
            content="Track your non-powered assets on the IoT platform. Simple. Reliable, Cost-effective. Over 100k assets connected. Containers, boxes, trailers, ULD."
          />
          <meta name="keywords" content="indoor location tracking, sigfox" />
          <meta name="application-name" content="IoT Platform" />
        </Helmet>
      );
    }

    return el;
  };

  return renderEls();
};

export default SntBrowserTabTitle;
